import React from 'react';
import styled from 'styled-components';

const resourceSymbols = {
  steel: { symbol: '🛠', color: 'brown' },
  titanium: { symbol: '⭐️', color: 'black' },
  plants: { symbol: '🌱', color: 'green' },
  energy: { symbol: '⚡', color: 'purple' },
  heat: { symbol: '🌡', color: 'orangered' },
};

const ResourceBox = ({ name, amount }) => {
  const isProduction = name.includes('Production');
  const nameKey = name.replace('Production', '');
  const { color, symbol } = resourceSymbols[nameKey];

  if (amount > 3) {
    return (
      <Wrapper isProduction={isProduction}>
        <p>{amount}</p>
        <SymbolBox color={color}>{symbol}</SymbolBox>
      </Wrapper>
    );
  }

  const symbols = Array(amount)
    .fill(symbol)
    .map((symbol, i) => {
      return (
        <SymbolBox key={i} color={color}>
          {symbol}
        </SymbolBox>
      );
    });

  return (
    <Wrapper isProduction={isProduction} amount={amount}>
      {symbols}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  overflow: hidden;
  min-width: 40px;
  min-height: 40px;
  font-weight: bold;
  display: grid;
  gap: 6px;
  padding: 8px;
  grid-template-columns: repeat(${({ amount }) => amount || 2}, 1fr);
  background-color: ${({ isProduction }) => (isProduction ? 'maroon' : 'none')};
  border-radius: 3px;
  font-size: 1.3rem;
`;

const SymbolBox = styled.div`
  width: 35px;
  height: 35px;
  background-color: ${({ color }) => color || 'white'};
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.2);
  padding: 3px;
`;

export default ResourceBox;
